import request from '../utils/request'


export function index(params) {
  return request({
    url: '/departmentUsers',
    method: 'get',
      params
  })
}
export function inventory(params) {
  return request({
    url: '/departmentUsers/inventory',
    method: 'get',
    params
  })
}

export function show(id) {
    return request({
      url: `/departmentUsers/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/departmentUsers',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/departmentUsers/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/departmentUsers/${id}`,
      method: 'delete',
    })
  }
